import { IconName } from '@wegroup/design-system';
import FLOW_TYPE from '../../../flows/src/constants/flowTypes';

import {
  flowIdSalesConversation,
  flowIdRiskAnalysisNL,
  flowIdRiskAnalysisBE,
  flowIdRiskAnalysisShortBE,
  flowIdCompanyScanBE,
  flowIdCompanyScanNL,
  flowIdDeMotoVerzekering,
  flowIdVillasureOfferFlow,
  flowIdVillasureContractFlow,
  flowIdPiaBoatOfferFlow,
  flowIdPiaBoatContractFlow,
  flowIdBikmoOfferFlow,
  flowIdBikmoContractFlow,
  flowIdCyclingVlaanderenOfferFlowId,
  flowIdCyclingVlaanderenContractFlowId,
  flowIdShortCheckupCompanyNL,
  flowIdShortCheckupCustomerNL,
  flowIdCfVerzekeringen,
  flowIdAskaTravelOffer,
  flowIdAskaTravelContract,
  flowIdShortCheckupCompanyBE,
  flowIdShortCheckupCustomerBE,
  flowIdGoudseCompanyScan,
} from '../../../flows/src/constants/flowIds';
import {
  FlowItem,
  FlowType,
  useAllFlows,
} from '../../../dashboard/src/api/getAllFlows';
import { useLocale } from '../../../../i18n';
import useAuth from '../../../app/src/features/authentication/hooks/useAuth';
import useIsNLplan from './useIsNLPlan';

export const FLOW_TYPE_META = {
  [flowIdSalesConversation]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'SALES-CONVERSATION',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralOthersChat',
  },
  [flowIdRiskAnalysisNL]: {
    type: FLOW_TYPE.RISKANALYSIS_NL,
    path: 'risk-analysis',
    name: 'Risk analysis',
    color: {
      background: '#E2DBE9',
      text: '#6F558A',
    },
    iconKey: 'GeneralNavigationRiskAnalysis',
  },
  [flowIdRiskAnalysisBE]: {
    type: FLOW_TYPE.RISKANALYSIS_BE,
    path: 'risk-analysis',
    name: 'CONVERSATIONS_FLOW-TYPE_RISK-ANALYSIS-BE-LONG',
    color: {
      background: '#E2DBE9',
      text: '#6F558A',
    },
    iconKey: 'GeneralNavigationRiskAnalysis',
  },
  [flowIdRiskAnalysisShortBE]: {
    type: FLOW_TYPE.RISKANALYSIS_BE_SHORT,
    path: 'risk-analysis',
    name: 'CONVERSATIONS_FLOW-TYPE_RISK-ANALYSIS-BE-SHORT',
    color: {
      background: '#E2DBE9',
      text: '#6F558A',
    },
    iconKey: 'GeneralNavigationRiskAnalysis',
  },
  [flowIdCompanyScanBE]: {
    type: FLOW_TYPE.COMPANY_SCAN,
    path: 'company-scan',
    name: 'COMPANY-SCAN',
    color: {
      background: 'green.50',
      text: 'green.500',
    },
    iconKey: 'GeneralOthersScan',
  },
  [flowIdCompanyScanNL]: {
    type: FLOW_TYPE.COMPANY_SCAN,
    path: 'company-scan',
    name: 'COMPANY-SCAN',
    color: {
      background: 'green.50',
      text: 'green.500',
    },
    iconKey: 'GeneralOthersScan',
  },
  [flowIdGoudseCompanyScan]: {
    type: FLOW_TYPE.COMPANY_SCAN,
    path: 'company-scan',
    name: 'COMPANY-SCAN',
    color: {
      background: 'green.50',
      text: 'green.500',
    },
    iconKey: 'GeneralOthersScan',
  },
  [flowIdDeMotoVerzekering]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'SALES-CONVERSATION',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralOthersChat',
  },
  [flowIdVillasureOfferFlow]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'VILLASURE',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralOthersChat',
  },
  [flowIdVillasureContractFlow]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'VILLASURE',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralOthersChat',
  },
  [flowIdShortCheckupCompanyNL]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'COMPANY-CHECKUP',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralNavigationOfficeInfo',
  },
  [flowIdShortCheckupCustomerNL]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'CHECKUP-CUSTOMER',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralOthersAvatar',
  },
  [flowIdShortCheckupCompanyBE]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'COMPANY-CHECKUP',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralNavigationOfficeInfo',
  },
  [flowIdShortCheckupCustomerBE]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'CHECKUP-CUSTOMER',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralOthersAvatar',
  },
  [flowIdCfVerzekeringen]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'CF-INSURANCES',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralOthersAvatar',
  },
  [flowIdAskaTravelOffer]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'ASKA_TRAVEL_OFFER',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralRiskObjectsFlight',
  },
  [flowIdAskaTravelContract]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'ASKA_TRAVEL_CONTRACT',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralRiskObjectsFlight',
  },
  [flowIdPiaBoatOfferFlow]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'PIA_BOAT',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralOthersChat',
  },
  [flowIdPiaBoatContractFlow]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'PIA_BOAT',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralOthersChat',
  },
  [flowIdBikmoOfferFlow]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'BIKMO',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralOthersChat',
  },
  [flowIdBikmoContractFlow]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'BIKMO',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralOthersChat',
  },
  [flowIdCyclingVlaanderenOfferFlowId]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'CYCLING-VLAANDEREN',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralOthersChat',
  },
  [flowIdCyclingVlaanderenContractFlowId]: {
    type: FLOW_TYPE.ADVISORY,
    path: 'sales-conversation',
    name: 'CYCLING-VLAANDEREN',
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    iconKey: 'GeneralOthersChat',
  },
};

export const flowsDefaultMeta = {
  type: FLOW_TYPE.ADVISORY,
  path: 'sales-conversation',
  name: 'UNKNOWN',
  color: {
    background: '#FFF2E5',
    text: '#FF8000',
  },
  iconKey: 'GeneralOthersChat',
};

export interface useFlowMetaReturn {
  id: string;
  type?: keyof typeof FLOW_TYPE;
  path?: 'sales-conversation' | 'risk-analysis' | 'company-scan';
  name: string;
  color: {
    text?: string;
    background?: string;
  };
  iconKey?: IconName;
}

const getMetaType = (type: FlowType): FLOW_TYPE => {
  switch (type) {
    case 'company_scan':
      return FLOW_TYPE.COMPANY_SCAN;
    case 'risk_analysis':
      return FLOW_TYPE.RISKANALYSIS_NL;
    default:
      return FLOW_TYPE.ADVISORY;
  }
};

const getMetaPath = (
  type: FlowType,
): 'sales-conversation' | 'risk-analysis' | 'company-scan' => {
  switch (type) {
    case 'company_scan':
      return 'company-scan';
    case 'risk_analysis':
      return 'risk-analysis';
    default:
      return 'sales-conversation';
  }
};

export const getFlowMetaObject = (flowObject: FlowItem): useFlowMetaReturn => {
  const { title, type, icon_key, id } = flowObject;

  return {
    id: id,
    color: {
      background: '#FFF2E5',
      text: '#FF8000',
    },
    name: title,
    path: getMetaPath(type),
    iconKey: icon_key,
    type: getMetaType(type),
  };
};

const useFlowMeta = (flowId: string): useFlowMetaReturn => {
  const { country } = useIsNLplan();
  const { distribution } = useAuth();
  const { userLang } = useLocale();
  const { data: allFlows } = useAllFlows({
    country_codes: [distribution.address.country_code || country],
    lang: userLang,
  });

  if (!FLOW_TYPE_META[flowId] && allFlows?.items) {
    const flowObject = allFlows.items.find(({ id }) => id === flowId);
    if (flowObject) {
      const { title, type, icon_key } = flowObject;

      return {
        id: flowId,
        color: {
          background: '#FFF2E5',
          text: '#FF8000',
        },
        name: title,
        path: getMetaPath(type),
        iconKey: icon_key,
        type: getMetaType(type),
      };
    }
  }

  return {
    ...(FLOW_TYPE_META[flowId] || flowsDefaultMeta),
    id: flowId,
  };
};

export default useFlowMeta;
